import { render } from "./P092.vue?vue&type=template&id=678239b4&scoped=true"
import script from "./P092.vue?vue&type=script&lang=js"
export * from "./P092.vue?vue&type=script&lang=js"

import "./P092.vue?vue&type=style&index=0&id=678239b4&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678239b4"]])

export default __exports__